import { Component, OnDestroy, HostListener, ViewChild, ElementRef } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { DemandaAnexoService } from '../../../core/services/demanda-anexo.service';

@Component({
  selector: 'app-demanda-anexo-visualizar',
  templateUrl: './demanda-anexo-visualizar.component.html',
  styleUrls: ['./demanda-anexo-visualizar.component.css']
})
export class DemandaAnexoVisualizarComponent implements OnDestroy {
  @ViewChild('fecharBotao') fecharBotao: ElementRef<HTMLButtonElement>;
  aberto = false;
  carregando = false;
  nome = '';
  erro = '';
  markdown = false;
  imagem = false;
  url: string;
  urlSegura: SafeResourceUrl;
  private consulta: Subscription;
  private origem: HTMLElement;
  private codigo: number;
  private anexo: number;

  constructor(private service: DemandaAnexoService, private sanitizer: DomSanitizer) {}

  podeVisualizar(nome: string): boolean {
    return /\.(pdf|md|markdown|doc|docx|xls|xlsx|jpg|jpeg|png|gif|webp|bmp|avif|ico)$/i.test(nome || '');
  }

  abrir(codigo: number, anexo: number, nome: string): void {
    this.fechar();
    this.origem = document.activeElement as HTMLElement;
    this.codigo = codigo;
    this.anexo = anexo;
    this.nome = nome;
    this.aberto = true;
    setTimeout(() => {
      if (this.aberto && this.fecharBotao) { this.fecharBotao.nativeElement.focus(); }
    });
    this.carregar();
  }

  carregar(): void {
    if (this.consulta) { this.consulta.unsubscribe(); }
    this.liberarUrl();
    this.erro = '';
    this.carregando = true;
    this.consulta = this.service.visualizar(this.codigo, this.anexo).subscribe(blob => {
      this.carregando = false;
      this.imagem = ['image/jpeg', 'image/png', 'image/gif', 'image/webp', 'image/bmp', 'image/avif', 'image/vnd.microsoft.icon', 'image/x-icon'].includes(blob.type);
      this.markdown = blob.type.split(';')[0] === 'text/html' && /\.(md|markdown)$/i.test(this.nome);
      if (blob.type !== 'application/pdf' && !this.imagem && !this.markdown) {
        this.erro = 'Não foi possível preparar a visualização deste documento.';
        return;
      }
      this.url = URL.createObjectURL(blob);
      // Apenas a URL local criada a partir da resposta autenticada é confiada.
      this.urlSegura = this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
    }, error => {
      this.carregando = false;
      const mensagens = {
        404: 'Arquivo não encontrado ou indisponível para consulta.',
        413: 'Este arquivo ultrapassa o limite de 50 MB para visualização.',
        415: 'A visualização está disponível para PDF, Markdown, Word, Excel e imagens compatíveis.',
        422: 'Não foi possível visualizar este arquivo. Ele pode estar inválido ou protegido por senha.',
        503: 'O serviço de visualização de documentos está indisponível. Tente novamente.'
      };
      this.erro = mensagens[error.status] || 'Não foi possível carregar o documento. Tente novamente.';
    });
  }

  @HostListener('document:keydown.escape')
  fechar(): void {
    if (this.consulta) { this.consulta.unsubscribe(); }
    this.liberarUrl();
    this.aberto = false;
    this.carregando = false;
    if (this.origem && document.contains(this.origem)) { this.origem.focus(); }
    this.origem = null;
  }

  private liberarUrl(): void {
    this.markdown = false;
    this.imagem = false;
    this.urlSegura = null;
    if (this.url) { URL.revokeObjectURL(this.url); }
    this.url = null;
  }

  ngOnDestroy(): void { this.fechar(); }
}
